/** Centralized localStorage key constants to avoid scattered magic strings */
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  DASHBOARD_LAYOUT: 'tsoft-dashboard-layout',
  LAST_REGIONAL_ORDER: 'tsoft-last-order',
  LAST_CITY_ORDER: 'tsoft-last-city-order',
  TRANSPORT_FILTERS: 'transportFilters',
  CITY_ROUNDS_FILTERS: 'cityRoundsFilters',
  ALL_ROUNDS_FILTERS: 'allRoundsFilters',

  LAST_UNIFIED_REGIONAL: 'tsoft-unified-order-regional',
  LAST_UNIFIED_CITY: 'tsoft-unified-order-city',

  // Persisted list-page filters
  F_ALL_ORDERS:      'f:all-orders',
  F_ALL_ROUNDS:      'f:all-rounds',
  F_REGIONAL_ORDERS: 'f:regional-orders',
  F_CITY_ORDERS:     'f:city-orders',
  F_UNIFIED_ORDERS:  'f:unified-orders',
} as const;
